import styled from 'styled-components';

const Button = styled.button<{ disabled?: boolean }>`
  background-color: var(--pink600);
  box-shadow: 0 0.25em 0.625em rgba(53,118,172,0.15);
  font-size: 1em;
  border-radius: 0.25em;
  min-width: 10em;
  height: 4em;
  border: none;
  color: var(--gray0);
  cursor: pointer;
  padding-left: 1.5em;
  padding-right: 1.5em;
  transition: all 0.2s ease;
  &:hover {
    background-color: ${props => props.disabled ? 'var(--pink600)' : 'var(--pink500)'};
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: var(--gray400);
    cursor: wait;
  }
`;

export default Button;
